import React from "react";

import { useTranslation } from "react-i18next";
import { Badge } from "reactstrap";

import SubHeader from "../../../../../components/Generic/SubHeader";
import { Company } from "../../../../../models/company";
import useStyles from "./styles";

const TitlePage = ({ company }: { company: Company }) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <SubHeader title={translate("reports") || ""}>
      {company?.profile && company?.profile?.name && (
        <div>
          <Badge className={classes.settingsHeaderBadge}>{`${company.status} ${translate(
            "company"
          )}`}</Badge>
          <span className={classes.settingsHeaderVersion} data-cy="company-profile-name">
            {translate("version")} |<strong> {company.profile?.name}</strong>
          </span>
        </div>
      )}
    </SubHeader>
  );
};

export default TitlePage;
